<template>
  <!-- prettier-ignore -->
  <div class="advisory">
    <div class="advisory__section">
      <the-typography
        type="heading06"
        tag="div"
        v-text="$t('form.name')"
      />
      <the-typography
        type="heading06"
        tag="div"
        class="advisor__text"
        v-text="advisorFullName"
      />
    </div>

    <div class="advisory__section">
      <the-typography
        type="heading06"
        tag="div"
        v-text="$t('form.email')"
      />
      <the-typography
        type="heading06"
        tag="div"
        class="advisor__text"
        v-text="partner.base.email"
      />
    </div>
  </div>
</template>

<script setup>
import { usePartner } from '@/hooks'

const { advisorFullName } = usePartner()

defineProps({
  partner: {
    type: Object,
    required: true,
  },
})
</script>

<style name="mobile" scoped>
.advisory {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;

  .advisory__section {
    min-width: 250px;
  }

  .advisor__text {
    font-weight: normal;
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .advisory {
    display: flex;
    flex-direction: row;
    margin-bottom: 40px;
    gap: 20px;
  }
}
</style>
